/* eslint-disable no-shadow */
enum LastMessageDateEnums {
  NEWEST = 'newest',
  OLDEST = 'oldest',
}
export default LastMessageDateEnums;
